import { Environment, ViewMode } from '@40seas/entities/common';
import { IntentType } from '@40seas/entities/intents';
import { UserRole } from '@40seas/entities/users';
import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { ModalContext } from '@40seas/frontend/libs/contexts';
import { useUser } from '@40seas/frontend/libs/hooks';
import { LocaleType } from '@40seas/frontend/libs/providers';
import { IntentModal, PaymentConfigurationContext } from '@40seas/payments';
import { PaymentContext, PaymentTheme, usePaymentContext } from '@40seas/payments-shared';
import { useLocaleState } from 'react-admin';
import { useModalContext } from './hooks/useModalContext';
import { IntentParams } from './types';
import { isGuestRole } from '@40seas/frontend/libs/hooks';

export const IntentsEmbed = ({
    params: { intentType, isLoading, data, callbacks, isEmbedded, isAuthenticationEnabled, configurationOverrides },
    theme,
}: {
    params: IntentParams;
    theme?: PaymentTheme;
}) => {
    const { isTestMode, viewMode } = useAppStore();
    const user = useUser();

    const environment = isTestMode ? Environment.Sandbox : Environment.Live;

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const modalContext = useModalContext(environment, data)!;

    const [locale] = useLocaleState();

    const paymentContext = usePaymentContext({
        intentType,
        dataProvider: modalContext?.dataProvider,
        isLoading,
        environment,
        data: data?.intent,
        isSeller: viewMode && viewMode !== ViewMode.Buyer,
        locale: locale as unknown as LocaleType,
        isAuthenticationEnabled: (!!isAuthenticationEnabled && !isGuestRole(user?.role as UserRole)) || intentType === IntentType.Signup,
    });

    const embedded = isEmbedded !== undefined ? isEmbedded : true;

    paymentContext.configuration = {
        ...paymentContext.configuration,
        ...configurationOverrides,
    };

    // SHIP4WD Theme Override
    // theme = {
    //     '.Picker': { borderColor: '#6E3DF7' },
    //     '.Picker--selected': { color: '#6E3DF7', borderColor: '#6E3DF7', boxShadow: 'none' },
    //     '.Button': {
    //         color: '#fff',
    //         backgroundColor: '#6E3DF7',
    //         border: '0px',
    //         borderradius: '12px',
    //     },
    //     '.Button:icon': {
    //         color: 'white',
    //     },
    //     '.Button:hovered': { backgroundColor: '#8A8AE3' },
    //     '.Button:disabled': { color: 'white', backgroundColor: '#C1C1E6' },
    //     '.Title': { color: '#000', fontSize: '40px', lineheight: '60px', margin: '0 0 8px 0' },
    //     '.MainText': { color: '#787E8E', fontsize: '16px', lineheight: '24px', margin: '0' },
    // };

    return (
        <ModalContext.Provider value={modalContext}>
            <PaymentContext.Provider
                value={{
                    ...paymentContext,
                    callbacks,
                    isEmbedded: embedded,
                    isInternal: configurationOverrides?.isInternal !== undefined ? configurationOverrides?.isInternal : true,
                    token: data?.token,
                }}
            >
                <PaymentConfigurationContext.Provider
                    value={{
                        theme: theme,
                        options: { type: 'embedded' },
                    }}
                >
                    <IntentModal />
                </PaymentConfigurationContext.Provider>
            </PaymentContext.Provider>
        </ModalContext.Provider>
    );
};
